<template>
  <div class="models">
    <div class="model-container text-center">
      <div class="panel panel-models">
        <div class="panel-body">
          <h3>{{ $t('message.selectYear') }}:</h3>
          <v-select
            :clearable="false"
            @input="selectYear()"
            v-model="selectedYear"
            :options="years"
          ></v-select>
          <div>
            <h3>{{ $t('message.selectModel') }}:</h3>
            <v-select
              @input="selectModel()"
              v-model="selectedModel"
              :options="models"
              :disabled="!selectedYear"
            ></v-select>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { mapActions } from 'vuex';

export default {
  name: 'Step2Model',
  computed: {
    models: {
      get() {
        return this.$store.state.availableModels;
      }
    },
    years: {
      get() {
        return this.$store.state.availableYears;
      }
    },
    minYear: {
      get() {
        return Math.min(...this.$store.state.availableYears);
      }
    },
    maxYear: {
      get() {
        return Math.max(...this.$store.state.availableYears);
      }
    },
    selectedYear: {
      get() {
        return this.$store.state.selectedYear;
      },
      set(value) {
        this.$store.commit('setYear', value);
      }
    },
    selectedModel: {
      set(value) {
        this.$store.commit('setModel', value);
      },
      get() {
        return this.$store.state.selectedModel;
      }
    }
  },
  methods: {
    ...mapActions(['selectYear', 'selectModel']),
    ...mapMutations(['setYear'])
  }
};
</script>

